import BrandAccounts from "./BrandAccounts-container";

/**
 * Export the top level component BrandAccounts-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default BrandAccounts;
